import { TApiResRegions } from '@app/core/models/region.model';
import { createAction, props } from '@ngrx/store';

export const setRegions = createAction('[Regions] Set regions', props<{ value: TApiResRegions }>());
